import { API_URL } from '../constants';

export async function fetchPlayer(id) {
  return await fetch(`${API_URL}/player/${id}`)
    .then(res => res.json())
    .then(res => res.data)
    .catch(error => console.error(error.message));
}
